import Notifications from './Notifications.vue'
import bus from './bus.js'
export default {
  install(Vue) {
    //Vue.util.defineReactive(Vue.prototype, '$notifications', []);
    Vue.prototype.$notify = function(notification) {
      bus.$emit('notify', notification)
    }
    Vue.component('notifications', Notifications)
  }
}
